module.exports = __webpack_public_path__ + "static/media/philip.01b1d6f1.png";